import React, { useContext } from "react";
import pptpage from './RealTimeGlossary_Coral.pdf'
import DashboardMain_Coral from "../DashboardMain_Coral/DashboardMain_Coral";

function PPTPageDIC_Coral() {
  return (
    <>
      <DashboardMain_Coral>
        <iframe src={pptpage} style={{ marginTop: "7%" }} frameborder="0" height="500em" width="100%" sandbox></iframe>
      </DashboardMain_Coral>
    </>
  );
}

export default PPTPageDIC_Coral;